const INTERNAL_DEV_DOMAINS = ['@jedix.com', '@goto.com', '@v2.jedix.com'];

export const isInternalDevEmail = (email) => {
  if (!email) {
    return false;
  }
  const lowerEmail = email.toLowerCase();
  return INTERNAL_DEV_DOMAINS.some((domain) => lowerEmail.endsWith(domain));
};

export default { isInternalDevEmail };
